import axios from "@/lib/axios";

class SubMerchantService {
  constructor() {
    this.api = axios;
  }

  async getSubMerchants() {
    const { data } = await this.api.get("/merchants/sub-merchants");

    return data;
  }

  // Alt bayinin paneline girmek için o bayinin admin kullanıcısına ait token.
  async getSubMerchantToken(subMerchantId) {
    const { data } = await this.api.post(
      `/merchants/sub-merchants/${subMerchantId}/token`,
    );

    return data;
  }
}

export default new SubMerchantService();
